// @flow
import React from "react";
import PhotoSettings from "./PhotoSettings";
import BoomerangSettings from "./BoomerangSettings";

/**
 * Convenience component that displays the settings of the currently active mode
 */
export function ActiveModeSettings(props) {
  switch (props.setting) {
    case "1":
    case "2":
    case "4":
    case "5":
    case "6":
    case "7":
    case "8":
      return <PhotoSettings />;
    case "3":
      return <BoomerangSettings />;
    default:
      return null;
  }
}

export default ActiveModeSettings;



// WEBPACK FOOTER //
// ./src/views/Configuration/config-form-sections/ActiveModeSettings.jsx